import { FullstateToAbvPipe } from '../../../../../../_helpers/_pipes/fullstate-to-abv.pipe';
import { SortPipe } from '../../../../../../_helpers/_pipes/sort.pipe';
import { DetailsSidebarComponent } from '../details-sidebar/details-sidebar.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { GetAddressService } from '../../../../../../_services/misc-services/get-address.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { AllHeaderComponent } from '../../../my-insurance/myinsurance-headers/all-header/all-header.component';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, DetailsSidebarComponent, SortPipe, FullstateToAbvPipe, AllHeaderComponent],
  selector: 'app-details-all',
  templateUrl: './details-all.component.html',
  styleUrls: ['./details-all.component.scss'],
})
export class DetailsAllComponent implements OnInit {
  isAcmic = false;
  @Input() policy: any;
  @Output() showToast: EventEmitter<any> = new EventEmitter<any>();
  address = 'address';
  apt = 'apt';
  aptDiv: boolean;
  safeURL: SafeUrl;
  isMobile: boolean;

  constructor(
    private getAddressService: GetAddressService,
    private acmicService: AcmicService
  ) { }

  getApartmentAndState(data): void {
    if (
      data.property != undefined &&
      data.property != null &&
      data.property.length > 0
    ) {
      const streetAddress = data.property[0].address.streetName;
      let addressArray = [];

      if (streetAddress.includes('|')) {
        addressArray = streetAddress.split('|');
        this.address = addressArray[0];
        this.apt = addressArray[1];
        this.aptDiv = true;
      } else {
        this.address = streetAddress;
        this.aptDiv = false;
      }
    } else {
      this.address = '';
      this.apt = '';
    }
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.getApartmentAndState(this.policy);
    this.safeURL = this.getAddressService.getAddress(this.policy, 'policy');
    this.checkScreen();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreen()
  }
  checkScreen() {
    this.isMobile = window.innerWidth <= 767;
  }
}
